export const mapArea = {
    center: {
      lat: -36.8676567,
      lng: 144.8707738
    },
    zoom: 7
  };

  export const googleAnalyticsCode = "UA-21971987-2";